<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="时间选择：" class="width100">
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item
              label=" 手机号："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.phone"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/sku/收货人/联系方式"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
        <div class="mb15">
          <el-button
            v-show="checkedIds.length != 0"
            size="mini"
            class="mr10"
            @click="batchGroup"
          >批量结算</el-button
          >
        </div>
        <el-alert
          v-if="checkedIds.length > 0 || allCheck"
          :title="
            allCheck
              ? `已选择  ${tableData.total}  项`
              : `已选择  ${checkedIds.length}  项`
          "
          type="info"
          show-icon
        />
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column label="ID" prop="integral_extract_id" min-width="60" />
        <el-table-column label="手机号" prop="user.phone" min-width="160" />
        <el-table-column label="呢称" prop="user.nickname" min-width="160" />
        <el-table-column label="提现金额" prop="integral_price" min-width="160" />
        <el-table-column label="甄豆余额" prop="integral_balance" min-width="100" />
        <el-table-column label="提现甄豆数量" prop="integral_num" min-width="100"/>
        <el-table-column label="提现甄豆数量" prop="integral_num" min-width="100"/>
        <el-table-column label="创建时间" prop="create_time" min-width="200"/>
        <el-table-column label="状态时间" prop="status_time" min-width="200"/>
        <el-table-column label="审核失败原因" prop="fail_msg" min-width="100"/>
        <el-table-column label="审核状态" prop="fail_msg" min-width="100">
        <template slot-scope="scope">
          <div :style="scope.row.status == -1?'color:red;':scope.row.status == 0?'':'color:#67c23a'">
            {{ scope.row.status == -1 ?'未通过':scope.row.status == 0 ?'审核中' :'已提现' }}
          </div>
        </template>
        </el-table-column>

        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status == 0"
                @click="handleStatusFn(scope.row.integral_extract_id)"
              >审核
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status == 0"
                @click="handleDetailFn(scope.row)"
              >甄豆明细
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>

    <el-dialog
      title="提现审核"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
     <div style="display: flex;align-items: center;justify-content: center">
       <el-radio v-model="status" label="1">审核通过</el-radio>
       <el-radio v-model="status" label="-1">审核拒绝</el-radio>
     </div>
      <div style="margin-top:40px;display: flex;align-items: flex-start;justify-content: center" v-if="status == -1">
        <span>拒绝原因：</span>
        <el-input
          style="width: 200px"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="fail_msg">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="statusConfirmFn">确 定</el-button>
  </span>
    </el-dialog>

    <el-dialog title="用户详情" :visible.sync="detailShow" width="1000px">
      <integralDetail ref="userDetails" :uid="uid" :cancel-time="cancel_time"/>
    </el-dialog>
  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import { roterPre } from "@/settings";
  import { fromList } from "@/libs/constants";
  import {
    integralExtractList
  } from "@/api/recovery";
  import cardsData from "@/components/cards";
  import {
    extractStatus,
    extractCard
  } from '@/api/user';
  import integralDetail from '@/components/integralDetail/index'
  export default {
    name: "appraisalEntityOrder",
    components: {
      cardsData,
      integralDetail
    },
    data() {
      return {
        status:'1',
        props: { checkStrictly: true, emitPath: false },
        moren: require("@/assets/images/f.png"),
        colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
        listLoading: true,
        wornLoadShow:false,
        tableData: {
          data: [],
          total: 0,
        },
        show:false,
        roterPre: roterPre,
        tableFrom: {
          recovery_uid: "moren",
          page: 1,
          limit: 20,
        },
        editNum:{},
        editObj:{},
        num:1,
        order_update_type:0,
        orderChartType: {},
        fromList: fromList,
        cardLists: [],
        timeVal: [],
        warehousTimeVal: [],
        type:'1',
        dialogVisible: false,
        dialogVisibleStatus: false,
        loading: false,
        formData: {
          product_list:[],
          order_return_list:[],
          user:{
            phone:''
          }
        },
        expressItem:{},
        ruleForm: {},
        appraisal_order_id: "",
        recoveryCateList: [],
        formStatusData: [],
        fail_msg:'',
        detailShow:false,
        statusList: [],
        recovery_price_total: 0,
        recovery_num_total: 0,
        chkName: "",
        checkedIds: [], // 订单当前页选中的数据
        noChecked: [], // 订单全选状态下当前页不选中的数据
        checkedPage: [],
        allCheck: false,
        cancel_time: null,
        recoveryOrderIdList: {
          recovery_order_id_list: [],
        },
        visibleWornHandle: false,
        visibleReturnHandle: false,
        recovery_order_id: 0,
        old_flag: 0,
      };
    },
    mounted() {
      this.getList(1);
      this.checkedIds = [];
    },
    methods: {
      /**
       * 审核弹框
       * */
      handleStatusFn(id){
        this.orderId=id
        this.dialogVisible = true
      },
      /**
       * 进行审核
       * */
      statusConfirmFn(){
        if(this.status == -1){
          if(!this.fail_msg){
            this.$message.error('输入拒绝原因')
            return
          }
        }
        let params = {
          status:this.status,
          fail_msg: this.fail_msg
        }
        extractStatus(this.orderId,params).then(res=>{
          this.$message.success(res.message)
          this.getList()
          this.handleClose()
        }).catch(err=>{
          this.$message.error(err.message)
        })
      },
      /**
       * 甄豆明细弹框
       * */
      handleDetailFn(row){
        this.uid = row.user.uid
        this.detailShow = true
      },
      handleClose(){
        this.dialogVisible =false
      },
      closeFn(){
        this.visibleWornHandle = false
      },
      // 选择时间
      selectChange(tab) {
        this.tableFrom.date = tab;
        this.tableFrom.page = 1;
        this.timeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeTime(e) {
        this.timeVal = e;
        this.tableFrom.date = e ? this.timeVal.join("-") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },

      // 选择时间
      selectWarehousChange(tab) {
        this.tableFrom.warehous_date = tab;
        this.tableFrom.page = 1;
        this.warehousTimeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeWarehousTime(e) {
        this.warehousTimeVal = e;
        this.tableFrom.warehous_date = e ? this.warehousTimeVal.join("/") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },
      // 列表
      getList(num) {
        this.listLoading = true;
        this.tableFrom.page = num ? num : this.tableFrom.page;
        integralExtractList(this.tableFrom)
          .then((res) => {
            this.tableData.data = res.data.list;
            this.tableData.total = res.data.count;
            this.checkedIds = [];
            this.listLoading = false;
          })
          .catch((res) => {
            this.listLoading = false;
            this.$message.error(res.message);
          });
        this.getCardList()
      },
      getCardList(){
        extractCard().then(res=>{
            this.cardLists = res.data
        })
      },
      pageChange(page) {
        this.tableFrom.page = page;
        this.getList("");
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val;
        this.getList("");
      },
    },
  };
</script>

<style scoped lang="scss">
  /deep/.boxDetial .el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-form-item {
    /*margin-bottom: 0!important;*/
  }
  .box-container {
    overflow: hidden;
  }

  .box-container .list {
    float: left;
    line-height: 40px;
  }

  .box-container .sp {
    width: 50%;
  }

  .box-container .sp3 {
    width: 33.3333%;
  }

  .box-container .sp100 {
    width: 100%;
  }
  .decla_row {
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 40px 0 0;
    padding: 20px 20px 0;
    box-sizing: border-box;
  }
  .batch_num {
    color: red;
    font-size: 16px;
  }
  .decla_title {
    font-size: 16px;
    font-weight: bold;
  }
  .box-container .list .name {
    display: inline-block;
    width: 150px;
    text-align: right;
    color: #606266;
  }
  .skuList {
    border-bottom: 2px solid #f4f4f5;
    margin-bottom: 10px;
  }
  .blodClass {
    font-size: 14px;
    color: red;
    font-weight: bold;
    .box-container .list.image {
  }
    margin-bottom: 40px;
  }

  .box-container .list.image img {
    position: relative;
    top: 40px;
  }

  /deep/ .el-form-item__content .el-rate {
    position: relative;
    top: 8px;
  }
  .cate_name {
    width: 200px;
  }
  .sku-tb {
    border: 1px solid black;
    border-collapse: collapse;
    margin-bottom: 20px;
    width: 100%;
    tr {
      th,
      td {
        border: 1px solid black;
        text-align: center;

        .sku-name {
          margin: 0 auto;
          width: 100px;
          /*height: 30px;*/
          /*overflow: hidden;*/
          line-height: 24px;
          text-overflow: ellipsis;
          /*word-break: keep-all;*/
        }
      }
    }
  }
</style>
